var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 63.333h50.666c3.484 0 6.334-2.85 6.334-6.333s-2.85-6.334-6.334-6.334H12.667c-3.484 0-6.334 2.85-6.334 6.334 0 3.483 2.85 6.333 6.334 6.333zm0-9.5H19v6.334h-6.333v-6.334zM6.333 19c0 3.483 2.85 6.333 6.334 6.333h50.666c3.484 0 6.334-2.85 6.334-6.333s-2.85-6.334-6.334-6.334H12.667c-3.484 0-6.334 2.85-6.334 6.334zM19 22.166h-6.333v-6.333H19v6.333zm-6.333 22.167h50.666c3.484 0 6.334-2.85 6.334-6.333s-2.85-6.334-6.334-6.334H12.667c-3.484 0-6.334 2.85-6.334 6.334 0 3.483 2.85 6.333 6.334 6.333zm0-9.5H19v6.334h-6.333v-6.334z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/StorageRounded.e8297c28.svg";
export { SvgStorageRounded as ReactComponent };